import { FC, memo } from 'react'

import { DateTimeProps } from './DateTimeProps'
import { formatDateTime } from './formatDateTime'

export const DateTime: FC<DateTimeProps> = memo(({ date, format: f, withTime = false, historical = true }) => {
  if (!date) return <>---</>
  const parsed = formatDateTime(date, withTime, historical, f)
  return <>{parsed || '---'}</>
})
